import React from 'react';
import {v4 as uuidv4} from 'uuid';

import {AppContext} from '../../../AppModule/Context';
import {withWidgetContext} from '../widgetContextProvider';

import ActionSelector from './actionSelector';
import ChatContainer from '../../chatComponents/chatContainer';
import ClientScheduleRequestContainer from '../../scheduleComponents/clientSchedulingComponents/widget/clientScheduleRequestContainer';
import PoweredByConsoltoComponent from './poweredByConsoltoComponent';
import LeadCollectorComponent from './leadCollectorComponent';
import CustomLinkComponent from './customLinkComponent';
import MessengerComponent from './messengerComponent';
import PhoneCallComponent from './phoneCallComponent';
import SinglePrivateHeaderChatBtnsComponent from '../../chatComponents/singlePrivateHeaderChatBtnsComponent';
import Spinner from '../../common/genericComponents/spinner';
import WidgetsRedirectComponent from './widgetsRedirectComponent';

import CFooterComponent from './cFooterComponent';
import WhatsappComponent from './whatsappComponent';
import WidgetHeaderComponent from './widgetHeaderComponent';
import WidgetVideoComponent from './widgetVideoComponent';

import AnalyticsService from '../../../services/analyticsService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './openWidgetComponent.css';

class OpenWidgetComponent extends React.Component {
  contScope = {};

  constructor(props) {
    super(props);
    this.state = {
      // fncObjToChatContainer: null,
      isMentor: !utilsService.getIsClient(),
      isInWidget: utilsService.getIsInWidget(),
      currentSelectedFile: null,
      showSendFileComponent: false,
      dragStarted: false,
    };
    this.isPersonalPage = utilsService.getIsPersonalPage();
  }

  componentDidMount() {
    // file drag events
    if (!this.props.isDemo) {
      window.addEventListener('dragenter', this.handleDragEnter);
      window.addEventListener('dragleave', this.handleDragLeave);
    }
  }

  componentWillUnmount = () => {
    if (!this.props.isDemo) {
      window.removeEventListener('dragenter', this.handleDragEnter);
      window.removeEventListener('dragleave', this.handleDragLeave);
      if (this.callSendFuncTimeoutId) {
        window.clearTimeout(this.callSendFuncTimeoutId);
      }
    }
  };

  handleDragEnter = (e) => {
    e.preventDefault();
    if (
      this.props.selectedWidgetAppType ===
      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT
    ) {
      var dt = e.dataTransfer;
      if (
        dt.types &&
        (dt.types.indexOf
          ? dt.types.indexOf('Files') !== -1
          : dt.types.contains('Files'))
      ) {
        this.setState({dragStarted: true});
      }
    }
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    if (!e.fromElement) {
      this.setState({dragStarted: false});
    }
  };

  callSendMessageFunc = (msg, msgType, metaData) => {
    if (msgType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEOCHAT_MESSAGE) {
      const callReqId = uuidv4();
      this.props?.widgetContext?.setCallReqId(callReqId);
      const mentorAvailabilityStatus =
        this.context.peersStatus[this.props.mentor.mentorDto.mentorOwnerId];
      metaData = JSON.stringify({callReqId, mentorAvailabilityStatus});
    }
    if (!this.refToChatContainer) {
      if (this.callSendFuncTimeoutId) {
        window.clearTimeout(this.callSendFuncTimeoutId);
      }
      this.callSendFuncTimeoutId = setTimeout(() => {
        this.callSendMessageFunc(msg, msgType, metaData);
      }, 100);
    } else {
      this.refToChatContainer.callSendMessageFunc(msg, msgType, metaData);
    }
  };
  sendGA = (eventAction) => {
    AnalyticsService.trackEvent({
      category: this.isPersonalPage
        ? VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.FRONT_PAGE
        : VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET,
      action: eventAction,
      label: this.props.mentor.mentorDto.profileName,
      value: '',
      sendToParent: this.props.enableWidgetAnalyticsForward === true,
    });
    this.sendCA(eventAction);
  };

  sendCA = (eventAction) => {
    var error = false;
    AnalyticsService.saveConsoltoAnalyticsEvent({
      category: this.isPersonalPage
        ? VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.FRONT_PAGE
        : VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET,
      action: eventAction,
      senderCreationTime: new Date().getTime(),
      userId: this.context.currentUser.userId,
      mentorId: this.props.mentor.mentorDto.mentorId,
      userRole: this.context.currentUser.role,
      error: error,
      dimensionsMap: {
        widgetId: this.props.widgetDto.widgetId,
        senderIsMentor: this.context.currentUser.isActive,
      },
    });
  };

  handleFileDrop = (file) => {
    this.setState({currentSelectedFile: file, showSendFileComponent: true});
  };
  openCloseSendFileComponent = (currentStateToShowPopup, file) => {
    this.setState({
      showSendFileComponent: currentStateToShowPopup,
      currentSelectedFile: file,
    });
  };
  onPrivateChatTabClicked = () => {
    this.props.widgetContext.setSelectedChatRoomId(
      this.props.widgetContext.privateChatRoomDto.privateChatRoomId,
    );
  };

  onSingleChatTabClicked = () => {
    this.props.widgetContext.setSelectedChatRoomId(
      this.props.mentor.mentorDto.mentorOwnerId,
    );
  };

  setRefreshShouldCollectUserInfo = (refreshShouldCollectUserInfo) => {
    this.setState({refreshShouldCollectUserInfo});
  };

  render() {
    const {callState, currentUser} = this.context;
    const {
      isMentor,
      isInWidget,
      refreshShouldCollectUserInfo,
      showSendFileComponent,
      currentSelectedFile,
      dragStarted,
    } = this.state;
    const {
      canMoveToTeamChat,
      isAutomatedCallHandled,
      isClearedManually,
      isDemo,
      isEntireWidgetHidden,
      isMultiWidget,
      inTeamChatScenario,
      postCallFail,
      showNotificationPopupForWait,
      actionClickData,
      dynamicFormTemplate,
      enableWidgetAnalyticsForward,
      bfi,
      mentor,
      mentorProfileImage,
      permissionsStatusesObj,
      selectedWidgetAppType,
      sessionTemplate,
      startValueFromQuery,
      widgetContext,
      widgetDto,
      widgetProfileImage,
      clearAutomatedCallLoop,
      dispatchConsoltoEvents,
      doWhenActionClick,
      handlePermissionsSuccess,
      onHeaderBackButton,
      onHeaderCloseButton,
      onFooterOptionSelected,
      resetActionClickData,
      setIsAutomatedCallHandled,
      setIsCallAudioOnly,
      setPermissionsStatusesObj,
      setShowPermissionsPopup,
      startVideochat,
    } = this.props;

    return (
      <React.Fragment>
        <div
          className={
            'et-open-widget-container ' +
            (this.context.callState ===
              VIDABOO_CONSTANTS.VIDEO_CALL_STATE.CALL_IN_PROGRESS ||
            this.context.callState ===
              VIDABOO_CONSTANTS.VIDEO_CALL_STATE.SENDING_VIDEO_TO_PEER ||
            this.context.callState ===
              VIDABOO_CONSTANTS.VIDEO_CALL_STATE.GETTING_VIDEO_FROM_PEER
              ? 'et-client-side-regular-call-in-progress'
              : '') +
            (this.isPersonalPage &&
            (utilsService.isMobileDevice() || //todomcss : ok
              this.context.windowScreenSize ===
                VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE)
              ? ' et-open-widget-pp-container'
              : '')
          }>
          <div
            className={
              (isDemo ? 'et-owc et-owc-widget-center' : 'et-owc') +
              (utilsService.isMobileDevice() || //todomcss : ok
              (this.isPersonalPage &&
                this.context.windowScreenSize ===
                  VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE)
                ? ' et-owc-mobile'
                : '')
            }>
            <WidgetHeaderComponent
              canMoveToTeamChat={canMoveToTeamChat}
              isDemo={isDemo}
              isEntireWidgetHidden={isEntireWidgetHidden}
              isMultiWidget={isMultiWidget}
              inTeamChatScenario={inTeamChatScenario}
              isPersonalPageAndMobile={
                this.isPersonalPage &&
                (utilsService.isMobileDevice() || //todomcss : ok
                  this.context.windowScreenSize ===
                    VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE)
              }
              mentor={mentor}
              mentorProfileImage={mentorProfileImage}
              selectedWidgetAppType={selectedWidgetAppType}
              sessionTemplate={sessionTemplate}
              widgetDto={widgetDto}
              widgetProfileImage={widgetProfileImage}
              onHeaderBackButton={onHeaderBackButton}
              onHeaderCloseButton={onHeaderCloseButton}
            />
            {selectedWidgetAppType ? (
              <div
                className={`et-v2-widget-body-container ${!this.isPersonalPage && selectedWidgetAppType === VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR ? 'et-v2-wbc-action-selector' : ''}`}>
                <div
                  className={`${
                    selectedWidgetAppType ===
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT
                      ? 'et-widget-chat-container-wrap'
                      : 'et-chat-hidden'
                  } ${
                    widgetContext.privateChatRoomDto?.privateChatRoomId
                      ? 'et-widget-single-private-chat-container-wrap'
                      : ''
                  }`}
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    if (
                      selectedWidgetAppType ===
                      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT
                    ) {
                      this.setState({dragStarted: false});
                      if (e.dataTransfer.files.length > 0) {
                        this.handleFileDrop(e.dataTransfer.files[0]);
                      }
                    }
                  }}
                  onPaste={(event) => {
                    var items = (
                      event.clipboardData || event.originalEvent.clipboardData
                    ).items;
                    for (let index in items) {
                      var item = items[index];
                      if (item.kind === 'file') {
                        var blob = item.getAsFile();
                        this.handleFileDrop(blob);
                      }
                    }
                  }}>
                  {widgetContext.privateChatRoomDto?.privateChatRoomId && (
                    <SinglePrivateHeaderChatBtnsComponent
                      isPrivateChatTabSelected={
                        widgetContext.selectedChatRoomId ===
                        widgetContext.privateChatRoomDto.privateChatRoomId
                      }
                      isSingleChatTabSelected={
                        widgetContext.selectedChatRoomId ===
                        mentor.mentorDto.mentorOwnerId
                      }
                      privateTabTxt={`${widgetContext.privateChatRoomDto.participantsCount} Participants`}
                      singleTabTxt={mentor.mentorDto.displayName}
                      onPrivateChatTabClicked={this.onPrivateChatTabClicked}
                      onSingleChatTabClicked={this.onSingleChatTabClicked}
                    />
                  )}
                  <ChatContainer
                    enableWidgetAnalyticsForward={enableWidgetAnalyticsForward}
                    isDemo={isDemo}
                    isInWidget={isInWidget}
                    isMentor={isMentor}
                    isVideo={false}
                    inTeamChatScenario={inTeamChatScenario}
                    refreshShouldCollectUserInfo={refreshShouldCollectUserInfo}
                    currentSelectedFile={currentSelectedFile}
                    currentUser={currentUser}
                    dragStarted={dragStarted}
                    mentor={mentor}
                    widgetDto={widgetDto}
                    dispatchConsoltoEvents={dispatchConsoltoEvents}
                    onRef={(ref) => (this.refToChatContainer = ref)}
                    openCloseSendFileComponent={this.openCloseSendFileComponent}
                    onFooterOptionSelected={onFooterOptionSelected}
                    restrictToPeer={mentor?.mentorDto?.mentorId}
                    selectedWidgetAppType={selectedWidgetAppType}
                    sendGA={this.sendGA}
                    doWhenActionClick={doWhenActionClick}
                    showSendFileComponent={showSendFileComponent}
                    // fncObj={this.fncObjToChatContainer}
                  />
                </div>
                {selectedWidgetAppType ===
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR && (
                  <ActionSelector
                    isDemo={isDemo}
                    foregroundWidgets={
                      mentor.mentorDto.appControlDto.foregroundWidgets
                    }
                    headerText={
                      mentor.mentorDto.appControlDto.widgetActionSelectorText
                    }
                    onFooterOptionSelected={onFooterOptionSelected}
                    widgetEditableTexts={
                      mentor.mentorDto.appControlDto?.widgetEditableTexts
                    }
                  />
                )}
                {selectedWidgetAppType ===
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER && (
                  <MessengerComponent
                    showNewUI
                    currentUser={currentUser}
                    mentor={mentor}
                    callSendMessageFunc={this.callSendMessageFunc}
                    dispatchConsoltoEvents={dispatchConsoltoEvents}
                    sendGA={this.sendGA}
                  />
                )}
                {selectedWidgetAppType ===
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.CUSTOM_LINK && (
                  <CustomLinkComponent
                    showNewUI
                    currentUser={currentUser}
                    mentor={mentor}
                    callSendMessageFunc={this.callSendMessageFunc}
                    dispatchConsoltoEvents={dispatchConsoltoEvents}
                    sendGA={this.sendGA}
                  />
                )}
                {selectedWidgetAppType ===
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR && (
                  <LeadCollectorComponent
                    isDemo={isDemo}
                    sendMailToMentor={true}
                    currentUser={currentUser}
                    dynamicFormTemplate={dynamicFormTemplate}
                    mentor={mentor}
                    // todo : ENABLE_PAY_PER_LEAD : uncomment this
                    // paymentFlowType={
                    //   VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE
                    //     .POST_LEAD_COLLECTOR
                    // }
                    callbackSuccessInfoSend={() => {
                      onFooterOptionSelected(
                        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_FORM_SUBMIT,
                      );
                      this.setRefreshShouldCollectUserInfo(true);
                    }}
                    callSendMessageFunc={this.callSendMessageFunc}
                    dispatchConsoltoEvents={dispatchConsoltoEvents}
                    selectedWidgetAppType={selectedWidgetAppType}
                    sendGA={this.sendGA}
                  />
                )}
                {selectedWidgetAppType ===
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL && (
                  <PhoneCallComponent
                    showNewUI
                    currentUser={currentUser}
                    mentor={mentor}
                    callSendMessageFunc={this.callSendMessageFunc}
                    dispatchConsoltoEvents={dispatchConsoltoEvents}
                    sendGA={this.sendGA}
                  />
                )}
                {selectedWidgetAppType ===
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING && (
                  <ClientScheduleRequestContainer
                    isDemo={isDemo}
                    currentUser={currentUser}
                    mentor={mentor}
                    sessionTemplateDto={sessionTemplate}
                    callSendMessageFunc={this.callSendMessageFunc}
                    dispatchConsoltoEvents={dispatchConsoltoEvents}
                    sendGA={this.sendGA}
                    widgetDto={widgetDto}
                  />
                )}
                {selectedWidgetAppType ===
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL && (
                  <WidgetVideoComponent
                    isAutomatedCallHandled={isAutomatedCallHandled}
                    isClearedManually={isClearedManually}
                    isDemo={isDemo}
                    showNotificationPopupForWait={showNotificationPopupForWait}
                    callState={callState}
                    actionClickData={actionClickData}
                    bfi={bfi}
                    mentor={mentor}
                    permissionsStatusesObj={permissionsStatusesObj}
                    postCallFail={postCallFail}
                    sessionTemplate={sessionTemplate}
                    startValueFromQuery={startValueFromQuery}
                    callSendMessageFunc={this.callSendMessageFunc}
                    clearAutomatedCallLoop={clearAutomatedCallLoop}
                    handlePermissionsSuccess={handlePermissionsSuccess}
                    onFooterOptionSelected={onFooterOptionSelected}
                    resetActionClickData={resetActionClickData}
                    sendGA={this.sendGA}
                    sendStartChatGA={() => {}}
                    setIsAutomatedCallHandled={setIsAutomatedCallHandled}
                    setIsCallAudioOnly={setIsCallAudioOnly}
                    setPermissionsStatusesObj={setPermissionsStatusesObj}
                    setRefreshShouldCollectUserInfo={
                      this.setRefreshShouldCollectUserInfo
                    }
                    setShowPermissionsPopup={setShowPermissionsPopup}
                    startVideochat={startVideochat}
                  />
                )}
                {selectedWidgetAppType ===
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP && (
                  <WhatsappComponent
                    showNewUI
                    currentUser={currentUser}
                    mentor={mentor}
                    callSendMessageFunc={this.callSendMessageFunc}
                    dispatchConsoltoEvents={dispatchConsoltoEvents}
                    sendGA={this.sendGA}
                  />
                )}
                {[
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_CALL_FAIL,
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_FORM_SUBMIT,
                ].includes(selectedWidgetAppType) && (
                  <WidgetsRedirectComponent
                    isPersonalPage={this.isPersonalPage}
                    mentor={mentor}
                    widgetsRedirectType={
                      selectedWidgetAppType ===
                      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_CALL_FAIL
                        ? VIDABOO_CONSTANTS.WIDGETS_REDIRECT_TYPES
                            .POST_CALL_FAIL_WIDGETS
                        : VIDABOO_CONSTANTS.WIDGETS_REDIRECT_TYPES
                            .POST_FORM_SUBMIT_WIDGETS
                    }
                    onFooterOptionSelected={onFooterOptionSelected}
                  />
                )}
              </div>
            ) : (
              <div className="et-v2-widget-spinner-wrap">
                <div className="et-v2-widget-body-container">
                  <Spinner />
                </div>
              </div>
            )}
            {selectedWidgetAppType &&
              selectedWidgetAppType !==
                VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR && (
                <CFooterComponent
                  isDemo={isDemo}
                  actionClickData={actionClickData}
                  mentor={mentor}
                  selectedWidgetAppType={selectedWidgetAppType}
                  onFooterOptionSelected={onFooterOptionSelected}
                />
              )}
            {!this.props.mentor?.mentorDto?.appControlDto?.whiteLabel && (
              <PoweredByConsoltoComponent
                isDemo={isDemo}
                category={
                  this.isPersonalPage
                    ? VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.FRONT_PAGE
                    : VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET
                }
                eventAction={
                  this.isPersonalPage
                    ? VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.FRONT_PAGE
                        .CONSOLTO_LINK
                    : VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CONSOLTO_LINK
                }
                mentorDto={mentor.mentorDto}
                utmMedium={
                  this.isPersonalPage
                    ? VIDABOO_CONSTANTS.UTM_MEDIUMS.PERSONAL_PAGE
                    : VIDABOO_CONSTANTS.UTM_MEDIUMS.WIDGET
                }
              />
            )}
          </div>
        </div>
        {dragStarted &&
          selectedWidgetAppType ===
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT && (
            <div className={`et-chat-container-overlay-file-drop`}>
              <div className="et-chat-container-overlay-file-drop-text">
                Drag File Here
              </div>
            </div>
          )}
      </React.Fragment>
    );
  }
}

OpenWidgetComponent.contextType = AppContext;
export default withWidgetContext(OpenWidgetComponent);
